import Store from "@/store";

export default {
	SET_CBT_LIST(state, { content, pageInfo }) {
		state.cbtList = content;
		state.cbtListPageInfo = pageInfo;
	},
	ADD_CBT(state, cbt) {
		state.cbtList.push(cbt);
	},
	DELETE_CBT(state, cbt) {
	},
	SET_SELECTED_CBT(state, cbt) {
		state.selectedCBT = cbt;
	},
	SET_ROOM_CBT(state, data) {
		const roomCBT = {};
		Object.keys(data).forEach(key => Object.assign(roomCBT, data[key]));
		state.roomCBT = roomCBT
	},
	CLEAN_ROOM_CBT(state) {
		state.roomCBT = {}
	},
	COMPLETE_ROOM_CBT_USER(state, { roomCbtUser }) {
		const _roomCbtUser = state.roomCBTUserList.find(_roomCbtUser => _roomCbtUser.userId === roomCbtUser.userId)
		_roomCbtUser.endDate = roomCbtUser.endDate
		_roomCbtUser.endType = roomCbtUser.endType
	},
	SET_ROOM_CBT_USER(state, roomCBTUserList) {
		roomCBTUserList = roomCBTUserList
			.map(roomCbtUser => {
				if (!roomCbtUser.userQuestionList) {
					roomCbtUser.userQuestionList = []
				}
				return roomCbtUser
			})

		state.roomCBTUserList = [
			...state.roomCBTUserList,
			...roomCBTUserList
		];
	},
	CLEAN_ROOM_CBT_USER_LIST(state) {
		state.roomCBTUserList = []
	},
	SET_ROOM_CBT_USER_ANSWER(state, userQuestionList) {
		state.roomCBT.questionList = state.roomCBT.questionList
			.map(question => {
				question.answerList.map(answer => {
					userQuestionList.map(userQuestion => {
						if (userQuestion.questionId === question.questionId) {
							userQuestion.userAnswerList.map(userAnswer => {
								if (userAnswer.answerId === answer.answerId) {
									answer.correct = true
								}
							})
						}
						return userQuestion
					})
					return answer
				})
				return question
			})
	},
	UPDATE_ROOM_CBT_USER_ANSWER(state, { roomCbtUser, userQuestion: { userQuestion } }) {
		const roomCBTUser = state.roomCBTUserList.find(_roomCbtUser => _roomCbtUser.userId === roomCbtUser.userId)
		const _userQuestion = roomCBTUser.userQuestionList.find(_userQuestion => _userQuestion.questionId === userQuestion.questionId)

		if (_userQuestion) {
			_userQuestion.userAnswerList = userQuestion.userAnswerList
		} else {
			roomCBTUser.userQuestionList.push(userQuestion)
		}
	},
	TOGGLE_SHOW_ANSWER(state) {
		state.showAnswer = !state.showAnswer;
	},
	SET_ROOM_CBT_DOC(state, roomCBTDoc) {
		state.roomCBTDoc = roomCBTDoc;
	},
	SET_CBT_LOG_LIST(state, { content, pageInfo }) {
		state.cbtLogList = content;
		state.cbtLogListPageInfo = pageInfo;
	},
	SET_CBT_LOG(state, cbtLog) {
		state.cbtLog = cbtLog;
	},
	SET_CBT_LOG_USER(state, cbtLogUser) {
		state.cbtLogUser = cbtLogUser;
	}
}
